"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcContractRevisionDropdown = class UcContractRevisionDropdown extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    otherRevisions(...args) {
        return _.filter(args[0], p => p.revision_number != args[1]);
    }
    contract;
    onContract(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("contract");
    }
    ux;
    dataMembers = ['ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                ux: null,
            },
        };
    }
    get selectedRevision() {
        if (this.loaded) {
            return _.find(this.contract.revisions, { revision_number: this.contract.revision_number });
        }
        return null;
    }
    async act_8358196963355853_navigate_6976_getActionArgs($event) {
        return {
            location: {
                name: "app.contract",
                query: {
                    rev: $event.scope.revision.revision_number,
                },
                params: {
                    id: this.contract.id,
                },
            },
        };
    }
    async evh_8358196963355853_clickPreventStop(event, scope) {
        return await this.actions.evh_8358196963355853_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_8356612450665535_showModal_6978_getActionArgs($event) {
        return {
            name: "CreateContractRevision",
            props: {
                contract: _.clone(this.contract),
            },
        };
    }
    async evh_8356612450665535_click(event, scope) {
        return await this.actions.evh_8356612450665535_click.executeFromDOM(this, event, scope);
    }
    async act_1382594685840889_closeComponent_6984_getActionArgs($event) {
        return {
            result: {
                close: true,
            },
        };
    }
    async act_1382594685840889_request_6982_getActionArgs($event) {
        return {
            operation: "delete_contract",
            data: this.contract,
            parameters: {
                rev: this.contract.revision_number,
            },
        };
    }
    async act_1382594685840889_request_6982_getConfirm($event) {
        return {
            message: this.$fn.gettext("Please confirm delete."),
            btnOk: this.$fn.gettext("Delete"),
        };
    }
    async evh_1382594685840889_click(event, scope) {
        return await this.actions.evh_1382594685840889_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_8358196963355853_navigate_6976 = new core_1.actions.NavigateAction({
            actionArgs: this.act_8358196963355853_navigate_6976_getActionArgs,
            events: [],
        });
        const evh_8358196963355853_clickPreventStop_6975 = new core_1.actions.EventHandlerImpl({
            action: act_8358196963355853_navigate_6976,
            event: "click.prevent.stop",
            displayName: "navigate",
        });
        const evh_8358196963355853_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8358196963355853_clickPreventStop_6975],
        });
        const act_8356612450665535_reloadComponentData_6980 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_8356612450665535_success_6979 = new core_1.actions.EventHandlerImpl({
            action: act_8356612450665535_reloadComponentData_6980,
            event: "success",
            displayName: "reloadComponentData",
        });
        const act_8356612450665535_showModal_6978 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8356612450665535_showModal_6978_getActionArgs,
            events: [evh_8356612450665535_success_6979],
        });
        const evh_8356612450665535_click_6977 = new core_1.actions.EventHandlerImpl({
            action: act_8356612450665535_showModal_6978,
            event: "click",
            displayName: "showModal",
        });
        const evh_8356612450665535_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8356612450665535_click_6977],
        });
        const act_1382594685840889_closeComponent_6984 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_1382594685840889_closeComponent_6984_getActionArgs,
            events: [],
        });
        const evh_1382594685840889_success_6983 = new core_1.actions.EventHandlerImpl({
            action: act_1382594685840889_closeComponent_6984,
            event: "success",
            displayName: "closeComponent",
        });
        const act_1382594685840889_request_6982 = new core_1.actions.RequestAction({
            actionArgs: this.act_1382594685840889_request_6982_getActionArgs,
            confirm: this.act_1382594685840889_request_6982_getConfirm,
            events: [evh_1382594685840889_success_6983],
        });
        const evh_1382594685840889_click_6981 = new core_1.actions.EventHandlerImpl({
            action: act_1382594685840889_request_6982,
            event: "click",
            displayName: "request",
        });
        const evh_1382594685840889_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1382594685840889_click_6981],
        });
        return {
            act_8358196963355853_navigate_6976,
            evh_8358196963355853_clickPreventStop_6975,
            evh_8358196963355853_clickPreventStop,
            act_8356612450665535_reloadComponentData_6980,
            evh_8356612450665535_success_6979,
            act_8356612450665535_showModal_6978,
            evh_8356612450665535_click_6977,
            evh_8356612450665535_click,
            act_1382594685840889_closeComponent_6984,
            evh_1382594685840889_success_6983,
            act_1382594685840889_request_6982,
            evh_1382594685840889_click_6981,
            evh_1382594685840889_click,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcContractRevisionDropdown.prototype, "contract", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('contract'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcContractRevisionDropdown.prototype, "onContract", null);
UcContractRevisionDropdown = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcContractRevisionDropdown);
exports.default = UcContractRevisionDropdown;
vue_property_decorator_1.Vue.component("UcContractRevisionDropdown", UcContractRevisionDropdown);
